module.exports = __webpack_public_path__ + "media/kfx.2a8e398c.wav";